import { useQuery } from 'react-query';
import { axiosInstance } from '../../config/axios';

export interface IksTerminalTerminal {
  globalMerchantId: string;
  pspMerchantId: string;
  terminalId: string;
  statusCode: string;
  type: string;
  brandCode: string;
  model: string;
  serialNo: string;
  ownerPspNo: number;
  ownerTerminalId: string;
  brandSharing: string;
  pinPad: string;
  contactless: string;
  connectionType: string;
  virtualPosUrl: string;
  hostingTaxNo: string;
  hostingTradeName: string;
  hostingUrl: string;
  paymentGwTaxNo: string;
  paymentGwTradeName: string;
  paymentGwUrl: string;
  fiscalNo: string;
  techPos: string;
  serviceProviderPspNo: number;
  referenceCode: string;
  serviceProviderPspMerchantId: string;
  pfMainMerchantId: string;
  responseCode: string;
  responseCodeExplanation: string;
}

interface SearchIksTerminalRequestData {
  statusCode: number;
  moreInformation: string | null;
  errors: any | null; // Define more specifically if known
  terminals: IksTerminalTerminal[];
}

export interface SearchIksTerminalRequestResponse {
  isSuccess: boolean;
  message: string;
  errorCode: string | null;
  requestId: string;
  data: SearchIksTerminalRequestData | null;
}

const searchIksTerminalRequest = async (referenceCode: string): Promise<SearchIksTerminalRequestResponse> => {
  const response = await axiosInstance.get(`/MerchantIKS/SearchIKSTerminalRequest?referenceCode=${referenceCode}`);
  return response.data;
};

export const useSearchIksTerminalRequest = (referenceCode: string, options?: any) => {
  return useQuery<SearchIksTerminalRequestResponse>(
    ['iksTerminalRequestSearch', referenceCode],
    () => searchIksTerminalRequest(referenceCode),
    options
  );
};
